import React, { ChangeEvent, Component, Ref } from "react";
import Modal from "react-modal";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IGetCatalogsDTO from "../../../models/DTO/IGetCatalogsDTO";
import IGetVendorSourcesCatalogItemsCsvDTO from "../../../models/DTO/IGetVendorSourcesCatalogItemsCsvDTO";
import IGetVendorSourcesCsvDTO from "../../../models/DTO/IGetVendorSourcesCsvDTO";
import IGetVendorSourcesDTO from "../../../models/DTO/IGetVendorSourcesDTO";
import IGetVendorSourcesLocationsCsvDTO from "../../../models/DTO/IGetVendorSourcesLocationsCsvDTO";
import IOnGetCatalogsDTO from "../../../models/DTO/IOnGetCatalogsDTO";
import IOnGetVendorSourcesCatalogItemsCsvDTO from "../../../models/DTO/IOnGetVendorSourcesCatalogItemsCsvDTO";
import IOnGetVendorSourcesCsvDTO from "../../../models/DTO/IOnGetVendorSourcesCsvDTO";
import IOnGetVendorSourcesDTO from "../../../models/DTO/IOnGetVendorSourcesDTO";
import IOnGetVendorSourcesLocationsCsvDTO from "../../../models/DTO/IOnGetVendorSourcesLocationsCsvDTO";
import IOnProcessVendorSourceCatalogItemDTO from "../../../models/DTO/IOnProcessVendorSourceCatalogItemDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IAction from "../../../models/IAction";
import IBreadcrumbs from "../../../models/IBreadcrumbs";
import ICatalog from "../../../models/ICatalog";
import IOwTableCols from "../../../models/IOwTableCols";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import IVendor_Source from "../../../models/IVendor_Source";
import UIService from "../../../services/UIService";
import AddressDisplay from "../../shared/AddressDisplay/AddressDisplay";
import OwActionBar from "../../shared/OwActionBar/OwActionBar";
import OwButton from "../../shared/OwButton/OwButton";
import OwGoogleStaticMap from "../../shared/OwGoogleStaticMap/OwGoogleStaticMap";
import { OwIconButton } from "../../shared/OwIconButton/OwIconButton";
import OwInputWrapper from "../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTable from "../../shared/OwTable/OwTable";
import OwTitle from "../../shared/OwTitle/OwTitle";
import PaginationBar from "../../shared/PaginationBar/PaginationBar";
import { VendorSourceCatalogItemsDetailView } from "../VendorSourceCatalogItemsDetailView/VendorSourceCatalogItemsDetailView";
import VendorSourceLocationDetailView from "../VendorSourceLocationDetailView/VendorSourceLocationDetailView";
import VendorSourceSidebar from "../VendorSourceSidebar/VendorSourceSidebar";
import "./VendorSources.scss";
import VendorSourcesUploadModal from "../VendorSourcesUploadModal/VendorSourcesUploadModal";
import IQBOPullVendorsDTO from "../../../models/DTO/IQBOPullVendorsDTO";
import IQBOOnPullVendorsDTO from "../../../models/DTO/IQBOOnPullVendorsDTO";
import INotification from "../../../models/INotification";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import { VendorSourcesHeader } from "../VendorSourcesHeader/VendorSourcesHeader";
import { Socket } from "socket.io-client";
import * as _ from "lodash-es";
import IQBOPullAndDownloadVendorsDTO from "../../../models/DTO/IQBOPullAndDownloadVendorsDTO";
import IQBOOnPullAndDownloadVendorsDTO from "../../../models/DTO/IQBOOnPullAndDownloadVendorsDTO";
import IntegrationsConnectedBar from "../../shared/IntegrationsConnectedBar/IntegrationsConnectedBar";
import IProcessVendorSourceDTO from "../../../models/DTO/IProcessVendorSourceDTO";
import IOnProcessVendorSourceDTO from "../../../models/DTO/IOnProcessVendorSourceDTO";
import IQBDCreateVendorSourcesDTO from "../../../models/DTO/IQBDCreateVendorSourcesDTO";
import IQBDOnCreateVendorSourcesDTO from "../../../models/DTO/IQBDOnCreateVendorSourcesDTO";
import { ConfirmDeleteOverlayFn } from "../../shared/ConfirmDeleteOverlayFn/ConfirmDeleteOverlayFn";
import {OwDeleteEditActions} from "../../shared/OwDeleteEditActions/OwDeleteEditActions";
import {SearchSection} from "../../shared/SearchSection/SearchSection";

type Props = {
    history: any;
    location: any;
    socket: Socket;
    toggleSidebar: (shouldBeVisible?: boolean) => void;
    setSidebarComponent: (component: any) => void;
    setActivityIndicator: (activityOn: boolean) => void;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
};

type State = {
    vendorSources: IVendor_Source[];
    totalVendorSources: number;
    crumbs: IBreadcrumbs[];
    columns: IOwTableCols[];
    offset: number;
    limit: number;
    isDataFetching: boolean;
    isInitialData: boolean;
    qboActive: boolean;
    qbdActive: boolean;
    name: string;
    modalIsOpen: boolean;
    modalComponent: any;
    actions: IAction[];
    catalogs: ICatalog[];
    showHiddenFeatures: boolean;
    confirmOverlayRef: Ref<HTMLElement> | null;
    sourceDeleteRow: HTMLElement | null;
    selectedVendorSource: IVendor_Source | null;
    deleteRow: string | null;
};

class VendorSources extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        const params = new URLSearchParams(this.props.location.search);

        const name = params.get("name");

        const actions: IAction[] = [
            {
                isGroup: true,
                name: "download_csv",
                groupActions: [
                    {
                        leftIconClass: "fad fa-download",
                        name: "vendor_sources",
                        fn: this.downloadVendorSourcesCSV,
                        disabledFn: () => {
                            return false;
                        },
                    },
                    {
                        leftIconClass: "fad fa-download",
                        name: "vendor_sources_locations",
                        fn: this.downloadVendorSourcesLocationsCSV,
                        disabledFn: () => {
                            return false;
                        },
                    },
                    {
                        leftIconClass: "fad fa-download",
                        name: "vendor_sources_catalog_items",
                        fn: this.downloadVendorSourcesCatalogItemsCSV,
                        disabledFn: () => {
                            return false;
                        },
                    },
                ],
            },
            {
                isGroup: true,
                name: "upload_csv",
                groupActions: [
                    {
                        leftIconClass: "fad fa-upload",
                        name: "upload",
                        fn: this.showUploadModal,
                        disabledFn: () => {
                            return false;
                        },
                        btnClass: "btn-danger",
                    },
                ],
            },
        ];

        if (this.props.supplierModel.Supplier_Integration.has_qbd) {
            actions.push({
                isGroup: true,
                name: "quickbooks_desktop",
                groupActions: [
                    {
                        name: "sync_vendors",
                        fn: this.syncQbdVendors,
                        disabledFn: () => {
                            return this.state.qbdActive;
                        },
                        isActive: () => {
                            return this.state.qbdActive;
                        },
                    },
                ],
            });
        }

        if (this.props.supplierModel.Supplier_Integration.has_qbo) {
            actions.push({
                isGroup: true,
                name: "quickbooks_online",
                groupActions: [
                    {
                        name: "pull_vendors",
                        fn: this.pullQboVendors,
                        disabledFn: () => {
                            return this.state.qboActive;
                        },
                        isActive: () => {
                            return this.state.qboActive;
                        },
                    },
                    {
                        name: "download_vendors",
                        fn: this.downloadQboVendors,
                        btnClass: () => {
                            return this.state.showHiddenFeatures ? "btn-warning" : "d-none";
                        },
                        disabledFn: () => {
                            return this.state.qboActive;
                        },
                        isActive: () => {
                            return this.state.qboActive;
                        },
                    },
                ],
            });
        }

        this.state = {
            modalIsOpen: false,
            modalComponent: null,
            vendorSources: [],
            totalVendorSources: 0,
            crumbs: [
                {
                    title: "purchase_orders",
                    url: "/purchase_orders",
                },
                {
                    title: "Vendor Sources",
                    url: "/vendor_sources",
                },
            ],
            columns: [
                {
                    title: "",
                    valueProp: "",
                    isActionsCol: true,
                    renderFn: this.renderActionsFn,
                    renderFnEmitsRow: true,
                    hasChevron: true,
                    showChevronFn: (row: IVendor_Source) => {
                        return true;
                    },
                },
                {
                    title: "name",
                    valueProp: "",
                    renderFn: this.renderNameFn,
                    renderFnEmitsRow: true,
                },
                {
                    title: "email",
                    valueProp: "email",
                },
                {
                    title: "bill_to",
                    valueProp: "",
                    renderFn: this.renderBillToFn,
                    renderFnEmitsRow: true,
                },
                {
                    title: "ship_to",
                    valueProp: "",
                    renderFn: this.renderShipToFn,
                    renderFnEmitsRow: true,
                },
            ],
            offset: 0,
            limit: 25,
            isDataFetching: false,
            isInitialData: true,
            qboActive: false,
            qbdActive: false,
            name: name || "",
            actions,
            catalogs: [],
            showHiddenFeatures: false,
            selectedVendorSource: null,
            confirmOverlayRef: null,
            sourceDeleteRow: null,
            deleteRow: null,
        };
    }

    componentDidMount() {
        this.props.socket.on(EndpointsEnum.PurchaseOrderOnGetVendorSources, this.onGetVendorSources);
        this.props.socket.on(EndpointsEnum.PurchaseOrderOnGetVendorSourcesCSV, this.onGetVendorSourcesCSV);
        this.props.socket.on(EndpointsEnum.PurchaseOrderOnGetVendorSourcesLocationsCSV, this.onGetVendorSourcesLocationsCSV);
        this.props.socket.on(EndpointsEnum.PurchaseOrderOnGetVendorSourcesCatalogItemsCSV, this.onGetVendorSourcesCatalogItemsCSV);
        this.props.socket.on(EndpointsEnum.CatalogsOnGetCatalogs, this.onGetCatalogs);
        this.props.socket.on(EndpointsEnum.PurchaseOrderOnProcessVendorSourceCatalogItem, this.onProcessVendorSourceCatalogItem);
        this.props.socket.on(EndpointsEnum.QBOOnPullVendors, this.onPullQboVendors);
        this.props.socket.on(EndpointsEnum.QBOOnPullAndDownloadVendors, this.onDownloadQboVendors);
        this.props.socket.on(EndpointsEnum.PurchaseOrderOnProcessVendorSource, this.onProcessVendorSource);
        this.props.socket.on(EndpointsEnum.QBDOnCreateVendorSourcesFromVendors, this.onSyncQbdVendors);
        this.props.socket.on(EndpointsEnum.Notify, this.notify);

        this.getVendorSources();
        this.getCatalogs();
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
        const params = new URLSearchParams(this.props.location.search);

        const name = params.get("name");

        if (name && prevState.name !== name) {
            this.setState(
                {
                    name: name || "",
                },
                () => {
                    if (this.state.name.length) {
                        this.getVendorSources();
                    }
                }
            );
        }

        if (!this.state.showHiddenFeatures) {
            // @ts-expect-error
            if (!_.isNil(window.showHiddenFeatures)) {
                this.setState({
                    showHiddenFeatures: true,
                });
            }
        }
    }

    componentWillUnmount() {
        this.props.socket.removeListener(EndpointsEnum.PurchaseOrderOnGetVendorSources, this.onGetVendorSources);
        this.props.socket.removeListener(EndpointsEnum.PurchaseOrderOnGetVendorSourcesCSV, this.onGetVendorSourcesCSV);
        this.props.socket.removeListener(EndpointsEnum.PurchaseOrderOnGetVendorSourcesLocationsCSV, this.onGetVendorSourcesLocationsCSV);
        this.props.socket.removeListener(
            EndpointsEnum.PurchaseOrderOnGetVendorSourcesCatalogItemsCSV,
            this.onGetVendorSourcesCatalogItemsCSV
        );
        this.props.socket.removeListener(EndpointsEnum.CatalogsOnGetCatalogs, this.onGetCatalogs);
        this.props.socket.removeListener(
            EndpointsEnum.PurchaseOrderOnProcessVendorSourceCatalogItem,
            this.onProcessVendorSourceCatalogItem
        );
        this.props.socket.removeListener(EndpointsEnum.QBOOnPullVendors, this.onPullQboVendors);
        this.props.socket.removeListener(EndpointsEnum.QBOOnPullAndDownloadVendors, this.onDownloadQboVendors);
        this.props.socket.removeListener(EndpointsEnum.QBDOnCreateVendorSourcesFromVendors, this.onSyncQbdVendors);
        this.props.socket.removeListener(EndpointsEnum.Notify, this.notify);
    }

    assignOverlayRef = (ref: React.Ref<HTMLElement>) => {
        if (!this.state.confirmOverlayRef) {
            this.setState({ confirmOverlayRef: ref });
        }
    };

    notify = () => {
        this.setState({
            qboActive: false,
        });
    };

    syncQbdVendors = () => {
        const payload: IQBDCreateVendorSourcesDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.QBDCreateVendorSourcesFromVendors, payload);

        this.setState({
            qbdActive: true,
        });
    };

    onSyncQbdVendors = (data: IQBDOnCreateVendorSourcesDTO) => {
        const notification: INotification = {
            message: "successfully_synced_vendors",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        this.props.notifyFn(null, notification);

        this.setState(
            {
                qbdActive: false,
            },
            () => {
                this.getVendorSources();
            }
        );
    };

    downloadQboVendors = () => {
        const payload: IQBOPullAndDownloadVendorsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.QBOPullAndDownloadVendors, payload);

        this.setState({
            qboActive: true,
        });
    };

    onDownloadQboVendors = (data: IQBOOnPullAndDownloadVendorsDTO) => {
        if (data) {
            UIService.downloadCSVData(data.csvData, data.filename);

            this.setState({
                qboActive: false,
            });
        }
    };

    pullQboVendors = () => {
        const payload: IQBOPullVendorsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.QBOPullVendors, payload);

        this.setState({
            qboActive: true,
        });
    };

    onPullQboVendors = (data: IQBOOnPullVendorsDTO) => {
        const notification: INotification = {
            message: "successfully_pulled_vendors",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        this.props.notifyFn(null, notification);

        this.setState(
            {
                qboActive: false,
            },
            () => {
                this.getVendorSources();
            }
        );
    };

    onProcessVendorSource = (data: IOnProcessVendorSourceDTO) => {
        const notification: INotification = {
            message: "successfully_processed_vendor_source",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        this.props.notifyFn(null, notification);

        this.setState(
            {
                selectedVendorSource: null,
                confirmOverlayRef: null,
                sourceDeleteRow: null,
                deleteRow: null,
            },
            () => {
                this.props.setActivityIndicator(false);
                this.getVendorSources();
            }
        );
    };

    onProcessVendorSourceCatalogItem = (data: IOnProcessVendorSourceCatalogItemDTO) => {
        this.getVendorSources();
    };

    getCatalogs = () => {
        const payload: IGetCatalogsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            callMeta: {
                view: "VendorSources",
                fn: "getCatalogs",
            },
        };

        this.props.socket.emit(EndpointsEnum.CatalogsGetCatalogs, payload);
    };

    onGetCatalogs = (data: IOnGetCatalogsDTO) => {
        this.setState({
            catalogs: data.catalogs,
        });
    };

    showUploadModal = () => {
        const component = (
            <VendorSourcesUploadModal
                closeModalFn={this.closeModal}
                socket={this.props.socket}
                notifyFn={this.props.notifyFn}
                userModel={this.props.userModel}
                supplierModel={this.props.supplierModel}
            />
        );

        this.setState({
            modalIsOpen: true,
            modalComponent: component,
        });
    };

    closeModal = () => {
        this.setState(
            {
                modalIsOpen: false,
                modalComponent: null,
            },
            () => {
                this.getVendorSources();
            }
        );
    };

    downloadVendorSourcesCSV = () => {
        const payload: IGetVendorSourcesCsvDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.PurchaseOrderGetVendorSourcesCSV, payload);
    };

    onGetVendorSourcesCSV = (data: IOnGetVendorSourcesCsvDTO) => {
        if (data) {
            UIService.downloadCSVData(data.csvData, data.filename);
        }
    };

    downloadVendorSourcesLocationsCSV = () => {
        const payload: IGetVendorSourcesLocationsCsvDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.PurchaseOrderGetVendorSourcesLocationsCSV, payload);
    };

    onGetVendorSourcesLocationsCSV = (data: IOnGetVendorSourcesLocationsCsvDTO) => {
        if (data) {
            UIService.downloadCSVData(data.csvData, data.filename);
        }
    };

    downloadVendorSourcesCatalogItemsCSV = () => {
        const payload: IGetVendorSourcesCatalogItemsCsvDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.PurchaseOrderGetVendorSourcesCatalogItemsCSV, payload);
    };

    onGetVendorSourcesCatalogItemsCSV = (data: IOnGetVendorSourcesCatalogItemsCsvDTO) => {
        if (data) {
            UIService.downloadCSVData(data.csvData, data.filename);
        }
    };

    renderActionsFn = (row: IVendor_Source, index: number) => {
        return (
            <div className={"d-flex"}>
                <OwDeleteEditActions
                    isEditMode={false}
                    onTrashClickFn={() => {
                        this.confirmDelete(row, index);
                    }}
                    onEditClickFn={() => {
                        this.openVendorSourceSidebar(row);
                    }}
                />
            </div>
        );
    };

    renderNameFn = (row: IVendor_Source) => {
        return (
            <div>
                <div className={"d-flex"}>
                    {row.name}
                    <IntegrationsConnectedBar
                        position={"left"}
                        supplierModel={this.props.supplierModel}
                        qboConnected={!!row.qbo_VendorId}
                        qbdConnected={!!row.qbd_ListID}
                        showIntegrations={{
                            quickbooksOnline: this.props.supplierModel.Supplier_Integration.has_qbo,
                            quickbooksDesktop: this.props.supplierModel.Supplier_Integration.has_qbd,
                        }}
                    />
                </div>
                {!row.customer_no ? null : (
                    <div className={"text-muted"}>
                        <OwLabel className={"me-1"} title={"customer_no"} />
                        {row.customer_no}
                    </div>
                )}
            </div>
        );
    };

    renderBillToFn = (row: IVendor_Source) => {
        if (row.Bill_To) {
            return (
                <div className={"d-flex"}>
                    {this.props.supplierModel.has_google_maps ? (
                        <OwGoogleStaticMap address={row.Bill_To} className={"me-2"} size={"120x120"} />
                    ) : null}
                    <AddressDisplay address={row.Bill_To} showName={true} showCompanyName={true} />
                </div>
            );
        } else {
            return null;
        }
    };

    renderShipToFn = (row: IVendor_Source) => {
        if (row.Ship_To) {
            return (
                <div className={"d-flex"}>
                    {this.props.supplierModel.has_google_maps ? (
                        <OwGoogleStaticMap address={row.Ship_To} className={"me-2"} size={"120x120"} />
                    ) : null}
                    <AddressDisplay address={row.Ship_To} showName={true} showCompanyName={true} />
                </div>
            );
        } else {
            return null;
        }
    };

    getVendorSources = () => {
        const payload: IGetVendorSourcesDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            limit: this.state.limit,
            offset: this.state.offset,
            includeCatalogItems: true,
        };

        if (this.state.name.length) {
            payload.queryString = `?name=${this.state.name}`;
        }

        this.props.socket.emit(EndpointsEnum.PurchaseOrderGetVendorSources, payload);

        this.setState({
            isDataFetching: true,
        });
    };

    onGetVendorSources = (data: IOnGetVendorSourcesDTO) => {
        this.setState({
            vendorSources: data.vendorSources,
            totalVendorSources: data.totalVendorSources,
            isDataFetching: false,
            isInitialData: false,
        });
    };

    cancelSidebar = (refreshData?: boolean) => {
        this.props.setSidebarComponent(null);
        this.props.toggleSidebar(false);

        if (refreshData) {
            this.setState(
                {
                    name: "",
                },
                () => {
                    this.getVendorSources();
                }
            );
        }
    };

    confirmDelete = (row: IVendor_Source, index: number) => {
        const elem = document.getElementById(`row-${index}`);

        this.setState({
            sourceDeleteRow: elem,
            selectedVendorSource: row,
            deleteRow: `row-${index}`,
        });
    };

    openVendorSourceSidebar = (vendorSource?: IVendor_Source) => {
        const component = (
            <VendorSourceSidebar
                cancelFn={this.cancelSidebar}
                notifyFn={this.props.notifyFn}
                socket={this.props.socket}
                userModel={this.props.userModel}
                supplierModel={this.props.supplierModel}
                vendorSource={vendorSource}
            />
        );

        this.props.setSidebarComponent(component);
        this.props.toggleSidebar(true);
    };

    paginationChanged = (offset: number, limit: number) => {
        this.setState(
            {
                offset,
                limit,
            },
            () => {
                this.getVendorSources();
            }
        );
    };

    handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.value;
        const name = e.target.name;

        const state: any = {
            [name]: value,
        };

        this.setState(state);
    };

    search = () => {
        this.getVendorSources();
    };

    reset = () => {
        this.setState(
            {
                name: "",
            },
            () => {
                this.props.history(`/vendor_sources`);
                this.getVendorSources();
            }
        );
    };

    getDetailView = (row: IVendor_Source, index: number) => {
        return (
            <div>
                <VendorSourceLocationDetailView
                    vendorSource={row}
                    userModel={this.props.userModel}
                    supplierModel={this.props.supplierModel}
                    setActivityIndicator={this.props.setActivityIndicator}
                    socket={this.props.socket}
                    notifyFn={this.props.notifyFn}
                    toggleSidebar={this.props.toggleSidebar}
                    refreshVendorSources={this.getVendorSources}
                    setSidebarComponent={this.props.setSidebarComponent}
                />

                <div className={"mt-3"}>
                    <VendorSourceCatalogItemsDetailView catalogs={this.state.catalogs} vendorSource={row} parentRowIndex={index} />
                </div>
            </div>
        );
    };

    enterSearch = (e: any) => {
        if (e.key === "Enter") {
            this.search();
        }
    };

    cancelDelete = () => {
        this.setState({
            sourceDeleteRow: null,
            deleteRow: null,
        });
    };

    commitDelete = () => {
        if (this.state.selectedVendorSource) {
            const payload: IProcessVendorSourceDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                vendorSource: this.state.selectedVendorSource,
                deleteFlag: true,
            };

            this.props.socket.emit(EndpointsEnum.PurchaseOrderProcessVendorSource, payload);

            this.props.setActivityIndicator(true);
        }
    };

    render() {
        let cardClass = "text-white bg-secondary dark-card";

        if (UIService.isMainViewLight()) {
            cardClass = "";
        }

        return (
            <div className="VendorSources position-relative">
                <div>
                    <VendorSourcesHeader notifyFn={this.props.notifyFn} />
                </div>

                <div className="row mt-2">
                    <div className={"col-12 d-flex align-items-center"}>
                        <OwTitle title={"vendor_sources"} leftIconName={"fad fa-handshake"} />
                        <div>
                            <OwButton
                                className={"ms-2 btn-warning"}
                                title={"create"}
                                leftIconClass={"fas fa-plus"}
                                fn={() => {
                                    this.openVendorSourceSidebar();
                                }}
                            />
                        </div>
                    </div>
                </div>

                <div className={"mb-2"}>
                    <SearchSection>
                        <div className={"d-flex"}>
                            <div className={"w-15r"}>
                                <OwLabel title={"name"} noBottomMargin={true} />
                                <OwInputWrapper
                                    name={"name"}
                                    value={this.state.name}
                                    fn={this.handleChange}
                                    onKeyDownFn={this.enterSearch}
                                />
                            </div>

                            <div className={"ms-2"}>
                                <OwLabel title={""} noBottomMargin={true} />
                                <div>
                                    <OwButton title={"search"} fn={this.search} />
                                    <OwButton title={"reset"} fn={this.reset} className={"btn-danger ms-1"} />
                                </div>
                            </div>
                        </div>
                    </SearchSection>
                </div>

                <div>
                    <OwActionBar toggleSmallTable={() => {}} colToggledFn={() => {}} columns={{}} actions={this.state.actions} />
                </div>

                <div className="row mt-3 position-relative">
                    <div className="col-12">
                        <ConfirmDeleteOverlayFn
                            handleConfirm={this.commitDelete}
                            handleCancel={this.cancelDelete}
                            message={"confirm_delete"}
                            targetElem={this.state.deleteRow}
                            leftAdjustment={-12}
                            nestedParentElem={'vendor-sources-table'}
                            skipMainView={true}
                        />

                        <OwTable
                            id={'vendor-sources-table'}
                            columns={this.state.columns}
                            dataSet={this.state.vendorSources}
                            userModel={this.props.userModel}
                            supplierModel={this.props.supplierModel}
                            dataFetch={this.state.isDataFetching}
                            initialData={this.state.isInitialData}
                            detailViewComponent={this.getDetailView}
                            tableConfig={{ tableStriped: true, hasDetailView: true }}
                        />
                    </div>
                </div>

                <div className={"row"}>
                    <div className={"col-12"}>
                        <PaginationBar
                            offset={this.state.offset}
                            limit={this.state.limit}
                            totalRecords={this.state.totalVendorSources}
                            onPaginationChanged={this.paginationChanged}
                        />
                    </div>
                </div>

                <div>
                    <Modal
                        isOpen={this.state.modalIsOpen}
                        contentLabel="Orderwerks"
                        shouldCloseOnOverlayClick={false}
                        className={"modalContentClass"}
                        overlayClassName={"modalOverlayClass"}>
                        {this.state.modalComponent}
                    </Modal>
                </div>
            </div>
        );
    }
}

export default VendorSources;
